import { render, staticRenderFns } from "./ExaminationTable.vue?vue&type=template&id=e93c9290&scoped=true"
import script from "./ExaminationTable.vue?vue&type=script&lang=js"
export * from "./ExaminationTable.vue?vue&type=script&lang=js"
import style0 from "./ExaminationTable.vue?vue&type=style&index=0&id=e93c9290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93c9290",
  null
  
)

export default component.exports